import React, { useState } from 'react';
import {
  Chip,
  FormControl,
  MenuItem,
  Select,
  SvgIcon,
  Typography,
} from '@mui/material';
import moment from 'moment';
import ConfirmDialog from '../../utils/ConfirmDialog';
import { ReactComponent as DeleteUserIcon } from '../../../../assets/common-assets/trash.svg';
import { activateMember, deleteUser } from '../../../../services/userApi';
import { classes } from './utils';
import CustomTooltip from '../../utils/CustomTooltip';
import { globalClasses } from '../../utils/globalUtils';
import ROLES from '../../../../constants/roles';
import { getLocalStorageItem } from '../../../../services/localStorageUtils';

const organizationAdminName = (params) => {
  const { data } = params;

  const fullName =
    data?.first_name !== undefined &&
    data?.first_name !== null &&
    data?.last_name !== undefined &&
    data?.last_name !== null
      ? `${data?.first_name} ${data?.last_name}`
      : null;

  return (
    <Typography variant="body1" fontWeight={400}>
      {fullName !== null ? fullName : '-'}
    </Typography>
  );
};

const organizationAdminPhoneNumber = (params) => {
  const phoneNumber = params?.data?.phone_no;

  return (
    <Typography variant="body1" fontWeight={400}>
      {phoneNumber !== undefined ? phoneNumber : '-'}
    </Typography>
  );
};
const remainingCredits = (params) => {
  const credits = params?.data?.creditHistories
    ? params?.data?.creditHistories.remaining_credits
    : '--';
  return (
    <Typography variant="body1" fontWeight={400}>
      {credits}
    </Typography>
  );
};

const organizationRegisteredDate = (params) => {
  const { value, data } = params;
  const formattedDate = data
    ? moment.utc(value).local().format('DD-MM-YYYY HH:mm:ss')
    : null;

  return (
    <Typography variant="body1" fontWeight={400}>
      {formattedDate || '-'}
    </Typography>
  );
};
const UserRole = (params) => {
  const getRoleLabel = (userRole) => {
    if (userRole === ROLES.SUPER_MANAGER) {
      return 'Super Manager';
    }
    if (userRole === ROLES.SALES_ADMIN) {
      return 'Sales Admin';
    }
    if (userRole === ROLES.SALES) {
      return 'Sales';
    }
  };

  const role = params?.data?.role?.role;
  const label = role !== undefined ? getRoleLabel(role) : '-';

  return (
    <Typography variant="body1" fontWeight={400}>
      {label}
    </Typography>
  );
};
const ActivityStatus = (params) => {
  const isActive = params?.value;
  const role = params?.loginRole;

  let title;
  if (role === ROLES.SUPER_ADMIN) {
    if (isActive) {
      title = 'Click here to in Inactive';
    } else {
      title = 'Click here to in Active';
    }
  } else {
    title = null;
  }

  if (params?.data) {
    if (params?.value !== undefined) {
      return (
        <CustomTooltip title={title}>
          <Chip
            size="small"
            label={isActive ? 'Active' : 'InActive'}
            className={`${globalClasses.whiteTextColor} ${globalClasses.cursorPointerClass} ${role === ROLES.SUPER_ADMIN ? globalClasses.cursorPointerClass : null} ${
              isActive ? classes.activeChipColor : classes.inActiveChipColor
            }`}
          />
        </CustomTooltip>
      );
    }
    return (
      <Typography variant="body1" fontWeight={400}>
        -
      </Typography>
    );
  }
};

const ActiveInActiveCellEditor = (params) => {
  const id = params?.data?.id;
  const isActive = params?.data?.is_active;
  const handleActiveStatus = async (event) => {
    try {
      const response = await activateMember(id, event.target.value);
      if (response) {
        params?.api.purgeInfiniteCache();
      }
    } catch (error) {
      return error;
    }
  };

  const activeState = true;
  return (
    <FormControl fullWidth>
      <Select size="small" value={isActive} onChange={handleActiveStatus}>
        <MenuItem disabled={isActive === activeState} value={activeState}>
          Active
        </MenuItem>
        <MenuItem disabled={isActive === !activeState} value={!activeState}>
          InActive
        </MenuItem>
      </Select>
    </FormControl>
  );
};

const CountryName = (params) => {
  if (params?.data) {
    if (params?.data?.country?.country_name !== undefined) {
      return (
        <Typography variant="body1" fontWeight={400}>
          {params?.data?.country?.country_name}
        </Typography>
      );
    }
    return (
      <Typography variant="body1" fontWeight={400}>
        -
      </Typography>
    );
  }
};

const ResponsiveCell = (params) => {
  const { value } = params;

  return (
    <Typography variant="body1" fontWeight={400}>
      {value !== undefined ? value : '-'}
    </Typography>
  );
};

const ActionCell = (params) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  const askingMessage = `Are you sure you want to delete super manager : ${params?.data?.first_name} ${params?.data?.last_name} ?`;

  const handleConfirmAction = async () => {
    const response = await deleteUser(params?.data?.id);

    if (response) {
      params?.api?.purgeInfiniteCache();
    }

    handleCloseDialog();
  };

  if (params?.data) {
    return (
      <>
        <SvgIcon
          component={DeleteUserIcon}
          className={classes.deleteUserIcon}
          onClick={() => handleOpenDialog()}
        />

        {isDialogOpen ? (
          <ConfirmDialog
            open={isDialogOpen}
            onClose={handleCloseDialog}
            onConfirm={handleConfirmAction}
            askingMessage={askingMessage}
          />
        ) : null}
      </>
    );
  }
};

const today = moment(); // Get today's date dynamically
const todayString = today.format('YYYY-MM-DD');

const superManagerColumnDef = (
  gridSettingData,
  gridKey,
  // setCustomFilterValue,
  customFilterValue,
  screenWidth,
) => {
  const loginRole = getLocalStorageItem('role');
  const isSmallScreen = screenWidth < 600;

  const myColumnData = [
    {
      headerName: 'Name',
      field: 'name',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      sortable: true,
      minWidth: isSmallScreen ? 120 : 150,
      maxWidth: isSmallScreen ? 180 : 250,
      cellRenderer: organizationAdminName,
      filter: true,
      suppressMenu: true,
      type: 'text',
      filterParams: {
        filterOptions: ['contains'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
      },
      pinned: isSmallScreen ? '' : 'left',
      lockPinned: true,
      lockPosition: true,
    },
    {
      headerName: 'Role',
      field: 'role',
      minWidth: isSmallScreen ? 100 : 150,
      maxWidth: isSmallScreen ? 150 : 200,
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
        customFilterValue,
      },
      sortable: true,
      // filter: 'CustomDropdownFilter',
      type: 'checkBox',
      filterParams: {
        // setCustomFilterValue,
        gridKey,
        customFilterValue,
      },
      cellRenderer: UserRole,
    },
    {
      headerName: 'Email',
      field: 'email',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      sortable: true,
      minWidth: isSmallScreen ? 120 : 150,
      maxWidth: isSmallScreen ? 200 : 250,
      cellRenderer: ResponsiveCell,
      filter: true,
      suppressMenu: true,
      type: 'text',
      filterParams: {
        filterOptions: ['contains'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
      },
    },
    {
      headerName: 'Date',
      field: 'created_at',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      sortable: true,
      minWidth: isSmallScreen ? 120 : 150,
      maxWidth: isSmallScreen ? 200 : 250,
      cellRenderer: organizationRegisteredDate,
      // filter: 'agDateColumnFilter',
      filterParams: {
        filterOptions: ['inRange'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
        maxValidDate: todayString,
      },
    },
    {
      headerName: 'Phone No.',
      field: 'phone',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      filter: 'true',
      suppressMenu: true,
      type: 'text',
      filterParams: {
        filterOptions: ['contains'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
      },
      minWidth: isSmallScreen ? 100 : 125,
      maxWidth: isSmallScreen ? 150 : 200,
      cellRenderer: organizationAdminPhoneNumber,
    },
    {
      headerName: 'Remaining Credits',
      field: 'remaining_credits',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      minWidth: isSmallScreen ? 120 : 150,
      maxWidth: isSmallScreen ? 200 : 250,
      cellRenderer: remainingCredits,
      filter: true,
      suppressMenu: true,
      type: 'text',
      filterParams: {
        filterOptions: ['contains'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
      },
    },
    {
      headerName: 'Status',
      field: 'is_active',
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
        customFilterValue,
      },
      editable: loginRole === ROLES.SUPER_ADMIN,
      sortable: true,
      minWidth: isSmallScreen ? 100 : 125,
      maxWidth: isSmallScreen ? 125 : 150,
      // filter: 'CustomDropdownFilter',
      type: 'checkBox',
      filterParams: {
        // setCustomFilterValue,
        gridKey,
        customFilterValue,
      },
      cellRenderParams: {
        loginRole,
      },
      cellRenderer: ActivityStatus,
      cellEditor: ActiveInActiveCellEditor,
    },
    {
      headerName: 'Country',
      field: 'country_name',
      minWidth: isSmallScreen ? 120 : 150,
      maxWidth: isSmallScreen ? 180 : 200,
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
        customFilterValue,
      },
      sortable: true,
      // filter: 'CustomDropdownFilter',
      type: 'checkBox',
      filterParams: {
        // setCustomFilterValue,
        gridKey,
        customFilterValue,
      },
      cellRenderer: CountryName,
    },
  ];

  if (loginRole === ROLES.SUPER_ADMIN) {
    myColumnData.push({
      headerName: ' ',
      field: ' ',
      headerComponent: 'ResponsiveSortingHeader',
      minWidth: 115,
      cellRenderer: ActionCell,
    });
  } else if (loginRole === ROLES.SUPER_MANAGER) {
    myColumnData.push({
      headerName: ' ',
      field: ' ',
      minWidth: 30,
      maxWidth: 30,
      resizable: false,
      pinned: 'right',
      lockPinned: true,
      lockPosition: true,
    });
  }
  return myColumnData;
};

export default superManagerColumnDef;
